import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import RedirectComponent from "@/app/components/ui/Redirect";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { useClickLogAPI } from "@/app/hooks/api_hooks/org/useClickLogAPI";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";

import { IBookingUserDetailsProps } from "../interface";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { useForm } from "react-hook-form";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { useEffect } from "react";

const SlotUserDetailsComponent: React.FC<IBookingUserDetailsProps> = (_props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { getRouteKey } = useRouter();

  const formHook = useForm<any>({
    mode: "onChange",
    defaultValues: {
      clinics: [],
    },
  });

  const routeId = getRouteKey("CUSTOMER_PROFILE", "id");
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { routeState } = useRouteInfo(routeId);
  const { petDetails, customerDetails, customerId, petId, customerPets } = routeState.state as ICustomerProfileState;
  const { execute: logClick } = useClickLogAPI();
  const vmsUserId = useAppSelector((state) => state.auth?.user?.email);

  const activePets = customerPets?.filter((pet: any) => pet.status !== "Deceased");
  const petListItem = useSelectMenuReducer(activePets, "name", "id");

  useEffect(() => {
    if (petDetails) {
      formHook.setValue("pet_id", petDetails?.id);
    }
  }, [petDetails]);

  const handelChnagePet = (petId: string) => {
    if (petId) {
      logClick({
        event_type: "CHANGE_PET_CLICK",
        scr_id: "BOOKING_PAGE",
        client_id: customerId,
        pet_id: petId,
        vms_user_id: vmsUserId,
        timestamp: Date.now(),
      });
      window.open(`/app/slots/available-slots/${customerId}/${petId}`, "_self");
    }
  };

  return (
    <>
      <div className="flex items-center gap-3">
        <p className="font-semibold text-base">Booking Appointment For</p>
        <SearchableSelectMenu
          onSelectItem={(item) => {
            formHook.setValue("pet_id", item.id);
            handelChnagePet(item.id);
          }}
          label=""
          errorMessages={[{ message: "", type: "required" }]}
          fieldError={formHook.formState.errors.petSpeciesId}
          register={formHook.register("pet_id", {
            required: false,
          })}
          containerClassName="mr-2"
          className=""
          showDropdownIcon
          showTypedErrors={false}
          placeholder="Pet Species"
          selectItems={petListItem}
          defaultSelected={petListItem?.filter((l1s) => l1s.id === formHook.watch("pet_id"))[0]}
          autoComplete="false"
        />
        <button className="text-xs bg-[#F3F3F3] text-[#606060] font-medium border border-[#E2E2E2] rounded-lg px-16 py-2">
          {customerDetails?.name}
        </button>
        <RedirectComponent
          className="ml-2"
          redirectTo={`${getRouteKey("APPOINTMENTS_TAB", "url")}/${customerId}/${petId}`}
        />
      </div>
    </>
  );
};
export default SlotUserDetailsComponent;
